import { AddOutlined } from '@mui/icons-material'
import { Box, Button, Drawer, Stack, TablePagination } from '@mui/material'
import type React from 'react'
import { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Header } from 'src/components/header/Header'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import Loading from 'src/components/loading/Loading'
import UserGroupList from './UserGroupList'
import { useQueryUsers } from './api'
import EditUserGroup from './editUser/EditUserGroup'
import { useQueryUserGroups } from './userGroups/api'
import { useUserGroupsFilters } from './userGroups/hooks/useUserGroupsFilters'

const UserGroupsScene: React.FC = () => {
  const { filters, changePage, changePageSize } = useUserGroupsFilters()
  const [isShowDrawer, setIsShowDrawer] = useState(false)
  const [activeUserGroupId, setActiveUserGroupId] = useState<
    number | undefined
  >(undefined)

  const { data: users = [], isLoading: isLoadingUsers } = useQueryUsers()

  const { data: userGroupsData, isLoading: isLoadingUserGroups } =
    useQueryUserGroups(filters)

  const userGroups = userGroupsData?.userGroups ?? []
  const count = userGroupsData?.count ?? 0
  const isLoading = isLoadingUserGroups || isLoadingUsers

  const openAddUserGroup = () => {
    setActiveUserGroupId(undefined)
    setIsShowDrawer(true)
  }

  const openEditUserGroup = (userGroupId: number) => {
    setActiveUserGroupId(userGroupId)
    setIsShowDrawer(true)
  }

  const onClose = () => {
    setIsShowDrawer(false)
    setActiveUserGroupId(undefined)
  }

  const onMutationSuccess = () => {
    setIsShowDrawer(false)
    setActiveUserGroupId(undefined)
  }

  const currentPage = filters.page
  const pageSize = filters.pageSize

  const renderUserGroupList = () => {
    if (isLoading) {
      return <Loading />
    }

    return (
      <Stack>
        <Stack direction="row" justifyContent="flex-end" sx={{ margin: 2 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddOutlined />}
            onClick={() => openAddUserGroup()}
          >
            ユーザーグループを追加
          </Button>
        </Stack>
        <UserGroupList
          userGroups={userGroups}
          openEditUserGroup={openEditUserGroup}
        />
      </Stack>
    )
  }

  return (
    <Stack>
      <Box
        sx={{
          height: 72,
        }}
      >
        <Header>
          <HeaderTitle title="ユーザーグループ" />
        </Header>
      </Box>
      {renderUserGroupList()}
      <Drawer
        anchor="right"
        open={isShowDrawer}
        onClose={() => onClose()}
        hideBackdrop={false}
        ModalProps={{
          keepMounted: false, // destroyOnClose={true} に相当
        }}
        slotProps={{
          paper: {
            sx: {
              maxHeight: '100%',
              width: '100%',
              maxWidth: 600,
            },
          },
        }}
      >
        <EditUserGroup
          activeUserGroupId={activeUserGroupId}
          userGroups={userGroups}
          users={users}
          onCancel={onClose}
          onSuccess={onMutationSuccess}
        />
      </Drawer>
      <TablePagination
        component="div"
        count={count}
        page={currentPage - 1}
        onPageChange={(_, newPage) => changePage(newPage + 1, pageSize)}
        rowsPerPage={pageSize}
        onRowsPerPageChange={event => {
          const size = parseInt(event.target.value, 10)
          changePageSize(size)
        }}
        rowsPerPageOptions={[25, 50, 100]}
        labelRowsPerPage="1ページあたり:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}〜${to} (${count !== -1 ? count : `不明`} 件中)`
        }
        sx={{
          '& .MuiTablePagination-selectLabel': {
            margin: 0,
          },
          '& .MuiTablePagination-displayedRows': {
            margin: 0,
          },
        }}
      />
    </Stack>
  )
}

export default withRouter(UserGroupsScene)
